module.exports = __webpack_public_path__ + "img/a.1887d9f9.jpg";